import { render, staticRenderFns } from "./DevDocsModal.vue?vue&type=template&id=04a03816&"
import script from "./DevDocsModal.vue?vue&type=script&lang=js&"
export * from "./DevDocsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports